import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';
// import KanaToHebonClass from '../../libs/util/KanaToHebonClass';
import HiraganaToRoman from '../../libs/util/HiraganaToRoman';

/**
 * かなをローマ字に変換 管理クラス
 */
export default class InputSupportKanaToHebonClass extends BaseClass {
  constructor(_id) {
    super();
    this.name = 'InputSupportKanaToHebonClass';

    this.id = _id;

    this.PROPERTY_CHANGE = 'propertychange';
    this.onKeyUpListerner = this.onKeyUp.bind(this);

    // this.kanaToHebon = new KanaToHebonClass();
    this.kana2roma = new HiraganaToRoman();
  }

  onCreate() {
    const self = this;
    this.inputTarget = $('[data-kanatohebon=' + this.id + ']');
    this.outputTarget = $('[data-kanatohebon_id=' + this.id + ']');

    this.inputTarget.on('keyup change compositionend', this.onKeyUpListerner);

    this.inputTarget.on('blur', (e) => {
      // カナ入力フォームからカーソルが外れたときに、ひらがなをカタカナにする
      $(e.currentTarget).val(self.hiraToKana($(e.currentTarget).val()));
      // ie(9.0以下)以外のブラウザために、propertychangeイベントを手動で実施する
      $(e.currentTarget).trigger(this.PROPERTY_CHANGE);
    });

    if (this.inputTarget.val() !== '' && this.outputTarget.val() === '') {
      // カタカナは入力されているのに、ローマ字が空だった場合入力補完する
      this.outputTarget.val(this.kana2roma.convert(this.inputTarget.val()).toUpperCase());
    }
  }

  onKeyUp(e) {
    const val = $(e.currentTarget).val();

    // console.log(this.name,"onKeyUp",val);
    // this.outputTarget.val(this.kanaToHebon.convert(val));
    this.outputTarget.val(this.kana2roma.convert(val).toUpperCase());
  }

  /**
   * ひらがなをカタカナに
   * @param {string} str
   */
  hiraToKana(str) {
    return str.replace(/[ぁ-ん]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) + 0x60);
    });
  }
}
